export default __webpack_public_path__ + "aba8f2e18053181a81b810c2ab9cf957.svg";